import { YouTubeProps } from "react-youtube";
import { ProductYouTube } from "../../../../../graphql/operations";
import useWindowSize from "../../../../../utils/useWindowSize";
import { useAnalyticsTracker } from "../../../../Atoms/Analytics";
import LazyYouTube from "../../../../Atoms/LazyYouTube";

interface Props {
  productId: string;
  youtube: ProductYouTube;
}

export default function YoutubeVideoPromotion({ productId, youtube }: Props) {
  const tracker = useAnalyticsTracker();
  const { width } = useWindowSize();

  const onPlayerReady: YouTubeProps["onReady"] = (event) => {
    // access to player in all event handlers via event.target
    event.target.pauseVideo();
  };
  const playerWidth = width > 640 ? 640 : 320;
  const playerHeight = width > 640 ? 390 : 195;
  const opts: YouTubeProps["opts"] = {
    height: playerHeight,
    width: playerWidth,
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
    },
  };

  return (
    <div>
      <p
        style={{
          marginBottom: 15,
          fontSize: 18,
        }}
      >
        <b>
          Check out YouTuber{" "}
          <span style={{ color: "#d81b60" }}>{youtube.title}</span> experiencing
          our tour
        </b>
      </p>
      <LazyYouTube
        onPlay={() =>
          tracker.trackEvent({
            category: "onpage",
            action: "click-youtubeVideo",
            label: `${youtube.title}-Video-${youtube.youtubeId}`,
          })
        }
        videoId={youtube.youtubeId}
        opts={opts}
        onReady={onPlayerReady}
      />
    </div>
  );
}
